module.exports = __webpack_public_path__ + "media/images/undo-3f64df670bf19c630e1cb672cc6b2eb0.svg";